export const types = {
    ADVANCEDASSIGN: 'ADVANCED-ASSIGN',
};